import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useLocalePath } from './useLocalePath'
import { isAuthRouteName } from '../router/authRoutes'

// Ready-to-bind :to for a "Sign in" link, everywhere one is rendered (nav, comment
// CTA, etc). Deliberately keyed off route.name, NOT router.resolve — the test
// setup mock's router.resolve() returns no `name`, so a resolve-based guard would
// pass every test while shipping broken. On an auth page the redirect key is
// omitted entirely (same contract as handleSessionExpired in api/client.js);
// otherwise it would stack — /autentificare?redirect=/autentificare?redirect=... —
// since Navigation.vue is mounted globally and renders this link on the login
// page itself (#565).
export function useLoginLink() {
  const route = useRoute()
  const { localePath } = useLocalePath()

  const loginLink = computed(() => {
    const to = localePath('Login')
    return isAuthRouteName(route.name) ? to : { ...to, query: { redirect: route.fullPath } }
  })

  return { loginLink }
}
